import { DetailsImagesActionTypes, DetailsImagesState, ImagesUIState, } from './types';
import { Image, ImageIsDirtyRequest, } from './model';

import { ImageResponse, CaseDocumentsRequest, DeleteDocumentRequest } from '../shared/model';
import { Reducer } from 'redux';

const initialState: DetailsImagesState = {
  images: [],
  requestState: ImagesUIState.NotSetYet
};

const mapImageResponseToImage = (res: ImageResponse): Image => {
  const image: Image = {
    createdOn: new Date(res.createdOn).toISOString(),
    description: res.description,
    documentStatus: res.documentStatus,
    documentType: res.documentType,
    filename: res.filename,
    isOnline: true,
    url: res.url,
    amazonKey: res.amazonKey,
    bucketName: res.bucketName,
    id: res.id,
    amazonId: res.amazonId,
    isChecked: false,
    thumbAmazonId: res.thumbAmazonId,
    thumbUrl: res.thumbUrl,
    content: '',
    isSelected: false,
    isDirty: false,
    createdByFirstName: '',
    createdByLastName: '',
    subjectLine: '',
    reportStatusTC: '',
    isForPreview: false,
    mimeType: '',
    hasBeenQueued: false,
  } 

  return image;
};

interface UploadImagesPayload {
  request: CaseDocumentsRequest;
  caseCode: string;
}
interface DeleteImagesPayload {
  request: DeleteDocumentRequest[];
}
interface SetImageRequestStatePayload {
  requestState: ImagesUIState;
}
interface SetImagesAsDirtyPayload {
  images: ImageIsDirtyRequest[];
}
interface GetImageScrSuccessPayload {
  id: number;
  url: string;
}
const isImageResponseArray = (payload: unknown): payload is ImageResponse[] =>
  Array.isArray(payload) && payload.every(item => 'id' in item && 'filename' in item);

const reducer: Reducer<DetailsImagesState> = (state = initialState, action) => {
  switch (action.type) {
    case DetailsImagesActionTypes.FETCH_IMAGES: {
      if (action.payload !== null && typeof action.payload === 'object' && 'caseCode' in action.payload) {
        return { ...state, caseCode: action.payload.caseCode, requestState: ImagesUIState.Downloading };
      }
      return { ...state };
    }
    case DetailsImagesActionTypes.FETCH_IMAGES_SUCCESS: {
      if (action.payload !== null && isImageResponseArray(action.payload)) {
        const mappedImages = action.payload.map(mapImageResponseToImage);
        return { ...state, images: mappedImages, requestState: ImagesUIState.Downloaded };
      }
      return { ...state };
    }
    case DetailsImagesActionTypes.UPLOAD_IMAGES: {
      if (action.payload !== null && typeof action.payload === 'object') {
        const payload = action.payload as UploadImagesPayload;
        return { ...state, request: payload.request, caseCode: payload.caseCode, requestState: ImagesUIState.Uploading };
      }
      return { ...state };
    }
    case DetailsImagesActionTypes.UPLOAD_IMAGES_SUCCESS: {
      const newImages: Image[] = (action.payload as ImageResponse[]).map(mapImageResponseToImage);
    
      const images = state.images.map(image => {
        const updatedImage = newImages.find(x => x.filename === image.filename && !image.isOnline);
        return updatedImage ? updatedImage : image;
      });
    
      return { ...state, images, requestState: ImagesUIState.Uploaded };
    }
    case DetailsImagesActionTypes.DELETE_IMAGES: {
      if (action.payload !== null && typeof action.payload === 'object') {
        const payload = action.payload as DeleteImagesPayload;
        return { ...state, request: payload.request, requestState: ImagesUIState.Deleting };
      }
      return { ...state };
    }
    case DetailsImagesActionTypes.DELETE_IMAGES_SUCCESS: {
      const idsToDelete = action.payload as number[];
      const images = state.images.filter(p => !idsToDelete.includes(p.id));
      return { ...state, requestState: ImagesUIState.Deleted, images };
    }
    case DetailsImagesActionTypes.SET_IMAGES_REQUEST_STATE: {
      if (action.payload !== null && typeof action.payload === 'object') {
        const payload = action.payload as SetImageRequestStatePayload;
        return { ...state, requestState: payload.requestState };
      }
      return { ...state };
    }
    case DetailsImagesActionTypes.FETCH_IMAGES_FAIL: {
      return { ...state, requestState: ImagesUIState.DownloadFail };
    }
    case DetailsImagesActionTypes.UPLOAD_IMAGES_FAIL: {
      return { ...state, requestState: ImagesUIState.UploadFail };
    }
    case DetailsImagesActionTypes.DELETE_IMAGES_FAIL: {
      return { ...state, requestState: ImagesUIState.DeleteFail };
    }
    case DetailsImagesActionTypes.RESET_STATE: {
      return initialState;
    }
    case DetailsImagesActionTypes.REPLACE_IMAGES: {
      if (action.payload !== null) {
        if(typeof action.payload === 'object' && Array.isArray(action.payload)) {
          return { ...state , images: action.payload };
        }
      }
      return { ...state };
    }
    case DetailsImagesActionTypes.SET_IMAGES_IS_DIRTY: {
      if (action.payload !== null && typeof action.payload === 'object') {
        const payload = action.payload as SetImagesAsDirtyPayload;

        const images = state.images.map(image => {
          const isDirtyRequest = payload.images.find(req => req.id === image.id);
          return isDirtyRequest ? { ...image, isDirty: isDirtyRequest.isDirty } : image;
        });

        return { ...state, images };
      }
      return { ...state };
    }
    case DetailsImagesActionTypes.GET_IMAGE_SRC_SUCCESS: {
      if (action.payload !== null && typeof action.payload === 'object') {
        const payload = action.payload as GetImageScrSuccessPayload;

        const images = state.images.map(image =>
          image.id === payload.id ? { ...image, url: payload.url } : image
        );

        return { ...state, images };
      }
      return { ...state };
    }
    case DetailsImagesActionTypes.IMPORT_REVIDEA_IMAGES: {
      return { ...state };
    }
    case DetailsImagesActionTypes.IMPORT_REVIDEA_IMAGES_SUCCESS: {
      return { ...state };
    }
    case DetailsImagesActionTypes.IMPORT_REVIDEA_IMAGES_FAIL: {
      return { ...state };
    }
    default: {
      return { ...state };
    }
  }
};

export { reducer as detailsImagesReducer, initialState as detailsImagesInitialState };
